import type { DATA_TABLE_COMPONENTS } from './enums';
import { capitalizeStr } from '@Helpers';

interface CellUniqueIdenfier {
  field: string;
  rowIndex: number;
  index: number;
}

interface DataTableEditField {
  key: string;
  field: string;
}

interface DataTableSizeSetting {
  label: string;
  disabled?: boolean;
  value: 'compact' | 'default' | 'large' | null;
}

interface RawDataTableColumn {
  default?: boolean;
  edit?: boolean;
  editable?: boolean;
  label: string;
  name: string;
  required?: boolean;
  sortable?: boolean;
  type: string; // TODO : AF-533 This should be an ENUM
  visible?: boolean;
}

interface DataTableColumn {
  field: string;
  header: string;
  editable?: boolean;
  sortable?: boolean;
  hidden?: boolean;
  visible?: boolean;
  settings?: {
    cellWidth?: string;
    component?: DATA_TABLE_COMPONENTS;
    edit?: {
      [key: string]: any;
      updateOnEditFields?: DataTableEditField[];
    };
    render?: {
      [key: string]: any;
    };
  };
}

class AFDataTableColumn implements DataTableColumn {
  editable?: boolean;
  field: string;
  header: string;
  sortable?: boolean;
  visible?: boolean;

  constructor(field: RawDataTableColumn, sortable?: boolean) {
    this.editable = !!field.editable;
    this.field = field.name;
    this.header = field.label || capitalizeStr(field.name);
    this.sortable = typeof sortable !== 'undefined' ? sortable : field.sortable;
    this.visible = typeof field?.visible === 'undefined' ? true : !!field.visible;
  }
}

export {
  type CellUniqueIdenfier,
  type DataTableColumn,
  type DataTableEditField,
  type DataTableSizeSetting,
  AFDataTableColumn,
};
